import { BASE_URL } from "./constant";

const API_BASE = (process.env.REACT_APP_API_BASE || BASE_URL || "").replace(/\/$/, "");

function buildUrl(path, params = {}) {
  const url = new URL(`${API_BASE}${path}`);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

async function request(path, params = {}) {
  const response = await fetch(buildUrl(path, params));
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.error || "Erreur de chargement");
  }

  return payload.data ?? payload;
}

export function buildMediaUrl(path) {
  if (!path) {
    return `${process.env.PUBLIC_URL}/images/bg.png`;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

export function getTitlePath(contentId) {
  return `/title/${contentId}`;
}

export function getPlayPath(content, episodeId = null) {
  if (!content?.id) return "/home";
  if (episodeId) return `/watch/${content.id}/episode/${episodeId}`;
  return content.type === "film" ? `/watch/${content.id}` : `/title/${content.id}`;
}

export function getDirectPlayPath(content, episodeId = null) {
  if (!content?.id) return "/home";
  if (episodeId) return `/watch/${content.id}/episode/${episodeId}`;
  return content.type === "film" ? `/watch/${content.id}` : `/title/${content.id}`;
}

export async function fetchHomeFeed(userId) {
  return request("/api/stream/home", { userId });
}

export async function fetchBrowseFeed({ type, userId }) {
  return request("/api/stream/browse", { type, userId });
}

export async function searchStreamingCatalog({ query, userId }) {
  return request("/api/stream/search", { q: query, userId });
}

export async function fetchTitleDetails(id, userId) {
  return request(`/api/stream/title/${id}`, { userId }); 
}

export async function fetchPlaybackContext({ id, userId, episodeId }) {
  return request(`/api/stream/play/${id}`, { userId, episodeId });
}
